import { useNavigate } from "react-router-dom";
import { UploadRecords } from "@/features/patient/records/components/UploadRecords";
import { usePatientData } from "@/portals/patient/context/PatientDataContext";

export function UploadPage() {
  const navigate = useNavigate();
  const { addRecords } = usePatientData();
  return (
    <UploadRecords
      onUpload={(records) => {
        addRecords(records);
        navigate("/patient");
      }}
    />
  );
}
